import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaCheck, FaRegHeart } from "react-icons/fa";
import { toast } from "react-toastify";
import { useProfile } from "../../hook/useProfile";
import { getCurrentUserId } from "../../utils/auth";
import { getSidebarMenus } from "../../constants/sidebarMenus";
import { getkycStatus } from "../../utils/auth";
import "../../css/User/Wallet.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleCheck,
  faIndianRupeeSign,
} from "@fortawesome/free-solid-svg-icons";
import { walletApi } from "../../api/walletApi";
import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";
import { FaThumbsUp } from "react-icons/fa";
import { Icon } from "@iconify/react";
// import ladderIcon from "../../assets/images/ladder.png";
import { FaInfoCircle } from "react-icons/fa";

function Wallet() {
  const kycStatus = getkycStatus();
  const currentUserId = getCurrentUserId();
  const { isProfileInfo, isLoading } = useProfile();
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [wallet, setWallet] = useState(null);
  const sidebarMenus = getSidebarMenus(currentUserId);
  const [activeTab, setActiveTab] = useState("forYou");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [activeSidebar, setActiveSidebar] = useState("wallet");
  const [showMsgDrawer, setShowMsgDrawer] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);
  const [activeLevel, setActiveLevel] = useState(1);
  const [isTransitionEnd, setIsTransitionEnd] = useState(2);
  const [isActive, setIsActive] = useState(false);

  // ✅ ADD THIS — near your other states
  const [transactions, setTransactions] = useState([]);
  const [transactionsLoading, setTransactionsLoading] = useState(false);

  const [transactionStats, setTransactionStats] = useState({
    totalWithdrawalsMade: 0,
    totalApprovedAmount: 0,
  });

  const feedTYPE = window.location.pathname.includes("/feed/public")
    ? "public"
    : "prime";
  const [feedType, setFeedType] = useState(feedTYPE);

  // Dummy transactions data
  // const transactions = [
  //   { id: 1, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 2, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  //   { id: 3, text: "Money Received from Alice", amount: "+ Rs.1,200.00" },
  // ];

  const handleToggleTransition = () => {

    console.log("transactions.length:", transactions.length);
    console.log("isTransitionEnd:", isTransitionEnd);
    console.log("isActive:", isActive);

    if (transactions.length > isTransitionEnd) {
      setIsTransitionEnd(transactions.length);
      setIsActive(true);
    } else {
      setIsTransitionEnd(2);
      setIsActive(false);
    }
  };

  // ✅ ADD THIS
    const fetchTransactions = async () => {
      try {
    setTransactionsLoading(true);
    const data = await walletApi.getWithdrawalHistory();
    if (data?.success) {
      setTransactions(data?.data || []);
      setTransactionStats({
        totalWithdrawalsMade: data?.totalWithdrawalsMade || 0,
        totalApprovedAmount: data?.totalApprovedAmount || 0,
      });
    }
      } catch (err) {
        console.error("Transaction fetch error:", err);
      } finally {
        setTransactionsLoading(false);
      }
    };

      useEffect(() => {
        fetchTransactions();
    }, []);

  // user id

  const fetchWallet = async () => {
    try {
      const data = await walletApi.getWallet();
      if (data.success) {
        setWallet(data);
      }
    } catch (err) {
      console.error("Wallet fetch error:", err);
    }
  };

  useEffect(() => {
    fetchWallet();
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileRef.current && !profileRef.current.contains(e.target)) {
        setShowProfile(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //naviagte profile page

  const goToProfile = () => {
    navigate("/profile");
  };

  // ========= WITHDRAW BUTTON FUNCTIONALITY START =========//

  const withdrawRequest = async (amount) => {
    try {
      console.log("Withdraw amount:", amount); // ✅ DEBUG

      const res = await walletApi.withdrawRequest({
        requestedAmount: amount,
      });

      console.log("Withdraw response:", res); // ✅ DEBUG

      if (res.success) {
        toast.success("Withdraw request submitted successfully");
        await fetchWallet();
        await fetchTransactions();
      } else {
        toast.error(res.message || "Withdraw failed");
      }
    } catch (err) {
      console.error("Withdraw error:", err);

      const errorMessage =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        err?.message ||
        "Something went wrong. Try again later";

      toast.error(errorMessage);
    }
  };

  // const followersCount = wallet?.followersCount || 0;
  // const minFollowersRequired = wallet?.minFollowersRequired || 0;

  // let percentage = 0;
  // let isUnlocked = false;

  // if (followersCount >= minFollowersRequired) {
  //   percentage = 100;
  //   isUnlocked = true;
  // } else if (followersCount > 0) {
  //   percentage = Math.min(100, Math.round((followersCount / minFollowersRequired) * 100)) || 0;
  //   isUnlocked = false;
  // } else {
  //   percentage = 0;
  //   isUnlocked = false;
  // }


  const followersCount = wallet?.followersCount || 0;
  const minFollowersRequired = wallet?.minFollowersRequired || 0;
  const monetizationLevel = wallet?.monetizationLevel || 1;
  const isUnlocked = monetizationLevel >= 2; // ✅ decided by backend now
  const [isWithdrawing, setIsWithdrawing] = useState(false);

  const [showMonetizationPopup, setShowMonetizationPopup] = useState(false); // ✅ ADD THIS

  let percentage = 0;
  if (followersCount >= minFollowersRequired) {
    percentage = 100;
  } else if (followersCount > 0) {
    percentage = Math.min(100, Math.round((followersCount / minFollowersRequired) * 100)) || 0;
  } else {
    percentage = 0;
  }

  useEffect(() => {
    if (isUnlocked) {
      setActiveLevel(2);
    } else {
      setActiveLevel(1);
    }
  }, [isUnlocked]);

  const handleLevelClick = (level) => {
    setActiveLevel(level);
  };

  const requiredFollowers = minFollowersRequired;
  const remainingFollowers = isUnlocked ? 0 : 1;

  // const handleWithdrawClick = () => {
  //   const status = isProfileInfo?.kycStatus;
  //   const aadhaarStatus = isProfileInfo?.adhaarVerified;

  //   if (aadhaarStatus === "NONE") {
  //     toast.error("First verify your Aadhaar.");
  //     setTimeout(() => navigate("/aadhaar-verification"), 1500);
  //     return;
  //   }

  //   if (aadhaarStatus === "REQUESTED") {
  //     toast.error("Your Aadhaar verification is in process.");
  //     return;
  //   }

  //   if (status === "REQUESTED") {
  //     toast.warning("Your KYC verification is in process");
  //     return;
  //   }

  //   if (status === "REJECTED") {
  //     toast.error("Your KYC was rejected. Please resubmit.");
  //     setTimeout(() => navigate("/kyc"), 1500);
  //     return;
  //   }
  //   withdrawRequest(wallet?.balance);
  // };

  // const handleWithdrawClick = async () => {
  //   // Prevent multiple clicks
  //   if (isWithdrawing) return;

  //   // console.log("Withdraw clicked");

  //   /* =========================
  //     BASIC FRONTEND CHECKS (LIGHT ONLY)
  //   ========================== */

  //   if (!wallet) {
  //     toast.error("Wallet not loaded yet. Please try again.");
  //     return;
  //   }

  //   if (wallet.balance <= 0) {
  //     toast.error("Insufficient balance to withdraw");
  //     return;
  //   }

  //   /* =========================
  //     API CALL (FINAL AUTHORITY)
  //   ========================== */

  //   try {
  //     setIsWithdrawing(true);

  //     const res = await walletApi.withdrawRequest({
  //       requestedAmount: wallet.balance,
  //     });

  //     console.log("Withdraw response:", res);

  //     if (res?.success) {
  //       toast.success("Withdrawal request submitted successfully");

  //       // Refresh data after success
  //       await fetchWallet();
  //       await fetchTransactions();
  //     } else {
  //       // fallback if backend sends success: false
  //       toast.error(res?.message || "Withdrawal failed");
  //     }
  //   } catch (err) {
  //     console.error("Withdraw error:", err);

  //     // Backend-driven error (IMPORTANT)
  //     const errorMessage =
  //       err?.response?.data?.error ||
  //       err?.response?.data?.message ||
  //       "Withdrawal not allowed at this time";

  //     toast.error(errorMessage);
  //   } finally {
  //     setIsWithdrawing(false);
  //   }
  // };

  const handleWithdrawClick = async () => {
    if (isWithdrawing) return;

    if (!wallet) {
      toast.error("Wallet not loaded yet. Please try again.");
      return;
    }

    if (wallet.balance <= 0) {
      toast.error("Insufficient balance to withdraw");
      return;
    }

    try {
      setIsWithdrawing(true);

      const res = await walletApi.withdrawRequest({
        requestedAmount: wallet.balance,
      });

      if (res?.success) {
        toast.success("Withdrawal request submitted successfully");
        await fetchWallet();
        await fetchTransactions();
      } else {
        toast.error(res?.message || res?.error || "Withdrawal failed");
      }

    } catch (err) {
      console.error("Withdraw error:", err);

      const errorMessage =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        "Withdrawal not allowed at this time";

      if (errorMessage === "Aadhar not verified") {
        toast.error("Please verify your Aadhaar first.");
        setTimeout(() => navigate("/aadhaar-verification"), 1500);
        return;
      }

      if (errorMessage === "KYC not verified") {
        toast.warning("Please complete your KYC to proceed.");
        setTimeout(() => navigate("/kyc"), 1500);
        return;
      }

      if (errorMessage === "Monetization limit not reached") {
        setShowMonetizationPopup(true);
        return;
      }

      toast.error(errorMessage);

    } finally {
      setIsWithdrawing(false);
    }
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Are you sure you want to logout?");
    if (confirmLogout) {
      navigate("/login");
    }
  };

  const formatBalance = (amount) => {
  const num = parseFloat(amount);
  if (isNaN(num)) return 0;
  return Number.isInteger(num) ? num : parseFloat(num.toFixed(2));
  };

  // Loader until profile loads

  // if (!isProfileInfo || isLoading) {
  //   return (
  //     <div
  //       className="d-flex justify-content-center align-items-center"
  //       style={{ height: "60vh" }}
  //     >
  //       <div className="text-center">

  //         <div className="spinner-grow text-warning mx-1"></div>
  //         <div className="spinner-grow text-warning mx-1"></div>
  //         <div className="spinner-grow text-warning mx-1"></div>

  //         <p className="mt-3 text-muted fw-semibold">
  //           Loading your wallet...
  //         </p>

  //       </div>
  //     </div>
  //   );
  // }

  return (

    <div className="container-xxl p-0">
      <div className="feed-page-wrapper">
        
        <TopHeader
          onToggleSidebar={() => setShowSidebar((prev) => !prev)}
          onOpenMessages={() => setShowMsgDrawer(true)}
          creditAmount={50}
          notificationCount={5}
          messageCount={0}
        />
        <div className="prime-layout-container .container-fluid">
          <div className="row">
            {!showSidebar && (
              <div
                className="left-sidebar-overlay d-md-none"
                onClick={() => setShowSidebar(true)}
              />
            )}

            <Sidebar
              showSidebar={showSidebar}
              sidebarMenus={sidebarMenus}
              activeSidebar={activeSidebar}
              feedType={feedType}
              onNavigate={(item) => navigate(item.path)}
              onLogout={handleLogout}
            />

            {/* ================= #ffeaeeb0 CENTER AREA ================= */}

            <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
              <div className="w-100 pb-5">
                <div className="container-fluid wallet-new-ui py-3">
                  <div className={isProfileInfo?.role === "PRIME" ? "" : "wallet-main-card shadow-sm"}>
                    {/* ===== BALANCE + RATES ===== */}
                    {isProfileInfo?.role === "PRIME" ? (
                      // ===== PRIME USER UI =====
                      <div className="prime-wallet-ui">

                        {/* TOTAL BALANCE CARD */}
                        <div className="prime-balance-card mb-3">
                          <div className="prime-balance-left">
                            <div className="d-flex align-items-center gap-2 mb-1">
                              <Icon icon="mdi:wallet-outline" className="prime-wallet-icon-sm" />
                              <span className="prime-balance-label">Total balance</span>
                            </div>
                            <h2 className="prime-balance-amount">₹ {wallet?.balance ?? 0}</h2>
                            <button
                              className="prime-withdraw-btn mt-2"
                              onClick={handleWithdrawClick}
                            >
                              Withdraw
                            </button>
                          </div>
                          <div className="prime-balance-right">
                          </div>
                        </div>

                        {/* PRIME USER INFO BOX */}
                        <div className="prime-info-box">
                          <div className="prime-star-icon">
                            <Icon icon="mdi:star" />
                          </div>
                          <div>
                            <p className="m-0 fw-bold">Prime User</p>
                            <p className="m-0 prime-info-text">
                              You earn ₹{wallet?.likeRate || 1} for every{" "}
                              <span className="prime-like-highlight">LIKE</span> on your monetized posts
                            </p>
                          </div>
                        </div>

                      </div>
                    ) : (
                      <>
                        <div className="row g-3">
                          {/* TOTAL BALANCE */}
                          <div className="col-lg-6">
                            <div className="card shadow-sm border-0 p-3 h-100 wallet-balance-card">
                              <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="wallet-balance-title m-0">
                                  Total Balance
                                </h6>
                                {/* <FontAwesomeIcon icon={faIndianRupeeSign} /> */}
                              </div>

                              <h2 className="fw-bold">
                                ₹ {formatBalance(wallet?.balance)}
                              </h2>

                              <button
                                className="btn btn-warning w-100 mt-3 rounded-pill"
                                onClick={handleWithdrawClick}
                              >
                                Withdraw
                              </button>
                            </div>
                          </div>

                          {/* MONETIZATION RATES */}
                          <div className="col-lg-6">
                            <div className="card shadow-sm border-0 p-3 h-100 monetization-card">
                              <h6 className="fw-semibold mb-3">
                                Monetization Rates
                              </h6>

                              <div className="row g-3 text-center">
                                <div className="col-4">
                                  <div className="rate-box rate-follow">
                                    <h5>₹ {wallet?.followerRate || 1}</h5>
                                    <p>Follow</p>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div className="rate-box rate-like">
                                    <h5>₹ {wallet?.likeRate || 1}</h5>
                                    <p>Like</p>
                                  </div>
                                </div>

                                <div className="col-4">
                                  <div className="rate-box rate-share">
                                    <h5>₹ {wallet?.repostRate || 0}</h5>
                                    <p>Share</p>
                                  </div>
                                </div>
                              </div>
                              <div className="info-note">
                                <FaInfoCircle className="info-icon" />
                                <span className="info-text">
                                  Note: Monetization Rates and limits may vary based on market conditions.
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ===== LEVEL SECTION ===== */}

                        <div
                          className="row g-3 mt-2"
                          style={{ width: "100%", margin: "0 auto" }}
                        >
                          <div className="col-md-6">
                            <div
                              className={activeLevel === 1 ? "level-card  d-flex justify-content-center align-items-center" : "level1 d-flex justify-content-center align-items-center disabled"}
                              onClick={() => handleLevelClick(1)}
                              style={{ cursor: "pointer" }}
                            >
                              <h3 className="m-0 d-flex align-items-center">
                              Level 1

                              {isUnlocked ? (
                                <Icon
                                  icon="fluent:arrow-growth-24-filled"   // <-- Replace with your chosen icon
                                  className="ms-2"
                                  width="18"
                                  height="18"
                                  color={activeLevel === 1 ? "#ffffff" : "#ff8800"}
                                />
                              ) : (
                                <FontAwesomeIcon
                                  icon={faCircleCheck}
                                  className="ms-2"
                                  style={{
                                    color: activeLevel === 1 ? "#ffffff" : "#ff8800",
                                  }}
                                />
                              )}
                            </h3>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div
                              className={activeLevel === 2 ? "level-card  d-flex justify-content-center align-items-center" : "level1 d-flex justify-content-center align-items-center disabled"}
                              onClick={() => handleLevelClick(2)}
                              style={{ cursor: "pointer" }}
                            >
                              <h3 className="m-0 d-flex justify-content-center align-items-center gap-1">
                                Level 2
                                {isUnlocked ? (
                                  <FontAwesomeIcon
                                    icon={faCircleCheck}
                                    className="level-check-icon ms-2"
                                  />
                                ) : (
                                  <Icon icon="mdi:lock" />
                                )}
                              </h3>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {/* Level-1 */}
                    {isProfileInfo?.role !== "PRIME" && activeLevel === 1 && (
                      <div className="card shadow-sm border-0 mt-4 p-4 level-unlocked-card">
                        <div className="text-center">
                          <div className="lock-icon mb-3">
                            <Icon icon="mdi:lock-open" width="40" />
                          </div>

                          <h4 className="fw-bold">
                            {isUnlocked ? "Level 1 Promoted" : "Level 1 Unlocked"}
                          </h4>

                          <p className="text-muted">
                            You will get Monetization for each follower.
                          </p>
                        </div>

                        <div className="benefit-box d-flex align-items-center">
                          <div className="icon-circle me-3">
                            <Icon icon="mdi:account-group" />
                          </div>
                          <div>
                            <p className="m-0">Per Follower Monetization</p>
                            <small>
                              For every new follower, you will earn ₹{wallet?.followerRate || 10}
                            </small>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* ===== LEVEL LOCKED CARD ===== */}
                    {isProfileInfo?.role !== "PRIME" && activeLevel === 2 && (
                      <div className="card shadow-sm border-0 mt-4 p-4 level-unlocked-card">
                        <div className="text-center">
                          <div className="lock-icon mb-3">
                            {isUnlocked ? (
                              <Icon icon="mdi:lock-open" width="40" />
                            ) : (
                              <Icon icon="mdi:lock" width="40" />
                            )}
                          </div>

                          <h4 className="fw-bold">
                            {isUnlocked ? "Level 2 Unlocked" : "Level 2 Locked"}
                          </h4>

                          <p className="text-muted">
                            You need{" "}
                            <b className="followers-highlight">
                              {/* {requiredFollowers} followers */}
                              {Math.max(0, Math.round(minFollowersRequired - followersCount))} followers

                            </b>{" "}
                            to unlock Level 2
                          </p>
                        </div>

                        {/* BENEFITS */}

                        <div className="benefit-box d-flex align-items-center mb-3">
                          <div className="heart-icon me-3">
                            <FaRegHeart />
                          </div>
                          <div>
                            <p className="m-0">
                              You will earn money on each <span className="theme-color fw-bold">LIKE</span> of your monotized
                              post
                            </p>
                            <small>For each like you will earn = ₹{wallet?.likeRate || 1}</small>
                          </div>
                        </div>

                        <div className="benefit-box d-flex align-items-center mb-3">
                          <div className="wallet_share-icon me-3">
                            <Icon icon="mdi:share" />
                          </div>

                          <div>
                            <p className="m-0">
                              You will earn money on each <span className="theme-color fw-bold">SHARE</span>
                            </p>
                            <small>For each share you will earn = ₹{wallet?.repostRate || 5}</small>
                          </div>
                        </div>

                        {/* PROGRESS */}

                        <div className="mt-3 follower-progress-box">
                          <div className="d-flex justify-content-between">
                            <span>
                              Requirement Step: {followersCount}/
                              {minFollowersRequired}
                            </span>
                            <span className="progress-percent">
                              {percentage}%
                            </span>
                          </div>

                          <div className="progress mt-2">
                            <div
                              className="progress-bar btn-warning"
                              style={{ width: `${percentage}%` }}
                            ></div>
                          </div>

                          <p className="mt-2 text-muted">
                            You need {Math.max(0, Math.round(minFollowersRequired - followersCount))} more followers to unlock Level
                            2
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                {isProfileInfo?.role === "PRIME" && (
                  <div className="prime-monetization-section mt-3 px-3">
                    <h6 className="fw-bold mb-3">Monetization Rates</h6>
                    <div className="prime-mono-rate-card">
                      <div className="prime-mono-icon">
                        <Icon icon="mdi:thumb-up" />
                      </div>
                      <div>
                        <p className="prime-mono-label">Per Like Earning</p>
                        <h5 className="prime-mono-amount">₹ {formatBalance(wallet?.likeRate || 1)}</h5>
                      </div>
                      <div className="prime-mono-badge">Like</div>
                    </div>
                  </div>
                )}

                <div className="wallet-transactions">
                  <div className="trans-header">
                    <h4>Recent Transactions</h4>
                  </div>

                  {/* ✅ Stats Row */}
                  {/* <div className="d-flex gap-3 mb-3">
                    <div className="transaction-stat-box">
                      <small className="text-muted">Total Withdrawals</small>
                      <p className="fw-bold m-0">{transactionStats.totalWithdrawalsMade}</p>
                    </div>
                    <div className="transaction-stat-box">
                      <small className="text-muted">Total Approved Amount</small>
                      <p className="fw-bold m-0">₹ {transactionStats.totalApprovedAmount}</p>
                    </div>
                  </div> */}

                  <div className="transition_history_container">
                    {/* ✅ Loading */}
                    {transactionsLoading ? (
                      <div className="text-center py-3">
                        <div className="spinner-grow text-warning mx-1"></div>
                        <div className="spinner-grow text-warning mx-1"></div>
                        <div className="spinner-grow text-warning mx-1"></div>
                      </div>

                    ) : transactions.length === 0 ? (
                      // ✅ Empty state
                      <div className="text-center py-4 text-muted">
                        <Icon icon="mdi:receipt-text-outline" width="40" />
                        <p className="mt-2">No transactions yet</p>
                      </div>

                    ) : (
                      // ✅ Real transactions
                      <>
                        {transactions.slice(0, isTransitionEnd).map((tx, idx) => (
                          <React.Fragment key={idx}>

                            {/* =========================
                                1. Withdrawal Paid
                            ========================== */}
                            {tx?.status === "PAID" && (
                              <div className="transaction-card">
                                <div className="transaction-left">
                                  <div
                                    className="check-icon"
                                    style={{ backgroundColor: "#e5ffe5" }}
                                  >
                                    <Icon icon="mdi:arrow-down" color="green" />
                                  </div>

                                  <div>
                                    <p className="tx-title">Withdrawal Paid</p>

                                    {tx?.paidOn && (
                                      <small className="text-muted">
                                        {new Date(tx.paidOn).toLocaleDateString("en-IN", {
                                          day: "numeric",
                                          month: "short",
                                          year: "numeric",
                                        })}
                                      </small>
                                    )}

                                    <br />

                                    <small className="badge bg-success">
                                      PAID
                                    </small>
                                  </div>
                                </div>

                                <p className="tx-amount text-success">
                                  ₹ {Number(tx?.approvedAmount || 0).toFixed(2)}
                                </p>
                              </div>
                            )}

                            {/* =========================
                                2. Withdrawal Approved
                            ========================== */}
                            {(tx?.status === "APPROVED" || tx?.status === "PAID") &&
                              tx?.approvedAmount > 0 && (
                                <div className="transaction-card">
                                  <div className="transaction-left">
                                    <div
                                      className="check-icon"
                                      style={{ backgroundColor: "#fff5dd" }}
                                    >
                                      <Icon icon="mdi:swap-vertical" color="#f59e0b" />
                                    </div>

                                    <div>
                                      <p className="tx-title">Withdrawal Approved</p>

                                      {tx?.approvedOn && (
                                        <small className="text-muted">
                                          {new Date(tx.approvedOn).toLocaleDateString("en-IN", {
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                          })}
                                        </small>
                                      )}

                                      <br />

                                      <small className="badge bg-success">
                                        APPROVED
                                      </small>
                                    </div>
                                  </div>

                                  <p className="tx-amount text-warning">
                                    ₹ {Number(tx?.approvedAmount || 0).toFixed(2)}
                                  </p>
                                </div>
                              )}

                            {/* =========================
                                3. Withdrawal Requested
                            ========================== */}
                            <div className="transaction-card">
                              <div className="transaction-left">
                                <div
                                  className="check-icon"
                                  style={{ backgroundColor: "#ffe5e5" }}
                                >
                                  <Icon icon="mdi:arrow-up" color="red" />
                                </div>

                                <div>
                                  <p className="tx-title">Withdrawal Requested</p>

                                  {tx?.createdAt && (
                                    <small className="text-muted">
                                      {new Date(tx.createdAt).toLocaleDateString("en-IN", {
                                        day: "numeric",
                                        month: "short",
                                        year: "numeric",
                                      })}
                                    </small>
                                  )}

                                  <br />

                                  <small
                                    className={`badge ${
                                      tx?.status === "PAID"
                                        ? "bg-success"
                                        : tx?.status === "APPROVED"
                                        ? "bg-success"
                                        : tx?.status === "REJECTED"
                                        ? "bg-danger"
                                        : "bg-warning text-dark"
                                    }`}
                                  >
                                    {tx?.status === "PAID"
                                      ? "PAID"
                                      : tx?.status === "APPROVED"
                                      ? "APPROVED"
                                      : tx?.status || "PENDING"}
                                  </small>
                                </div>
                              </div>

                              <p className="tx-amount text-danger">
                                ₹ {Number(tx?.requestedAmount || 0).toFixed(2)}
                              </p>
                            </div>

                          </React.Fragment>
                        ))}

                        <div className="view-all-bottom">
                          {/* ✅ Only show button if transactions are more than 5 */}
                          {transactions.length > 2 && (
                            <span onClick={handleToggleTransition}>
                              {isActive ? "View Less" : "View All"}
                            </span>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

            {/* ✅ ADD POPUP HERE — before closing divs */}
      {showMonetizationPopup && (
        <div className="monetization-popup-overlay">
          <div className="monetization-popup-box">
            <div className="monetization-popup-icon">
              <Icon icon="mdi:lock" width="40" color="#ff8800" />
            </div>
            <h5 className="fw-bold mt-3">Monetization Limit Not Reached</h5>
            <p className="text-muted">
              You have not reached the required followers to unlock withdrawal.
              Keep growing your audience!
            </p>
            <button
              className="btn btn-warning rounded-pill px-4"
              onClick={() => setShowMonetizationPopup(false)}
            >
              OK, Got it
            </button>
          </div>
        </div>
      )}
        
      </div>
    </div>


  );
}
export default Wallet;
